<template>
    <!--
              Otevření dropdownu -> přidat třídy "chosen-container-active chosen-with-drop"
    -->
    <div
            :class="{'chosen-container-active chosen-with-drop' : isOpen}"
            class="chosen-container chosen-container-single chosen-container-single-nosearch"
            style="--min-width: 350px;"
            v-click-outside="close"
    >
        <a @click="isOpen = true" class="chosen-single">
            <!-- Doplnit vybraný prvek - jeho duplikát -->
                <span class="current-result" v-html="selectedText"></span>
                <div>
                    <b></b>
                </div>
        </a>
        <div class="chosen-drop">
            <ul class="chosen-results">
                <!-- Vybraný prvek - má třídu highlighted-->
                <li
                        :class="{'group-result' : item.isGroup,  'active-result' : !item.isGroup, 'group-option' : item.groupOption, 'result-selected highlighted': (((!item.groupOption && current == item.id) || (item.groupOption && current.id == item.id && current.chainedValue == item.chainedId)) &&  !customIsSelected)}"
                        class="text-nowrap"
                        :key="'' + item.id + '_' + item.chainedId"
                        @click="setValue({isItem: !item.isGroup, value: item.id, chainedId: item.chainedId})"
                        v-for="item in flatValues"
                ><span class="color-dot" v-if="item.color" :style="{'background-color' : item.color}"></span>
                <span class="chosen-result-inner" v-html="item.label"></span>
                </li>
                <!-- Vlastní rozměr -->
                <li :class="{'active-result group-option' : true, 'result-selected highlighted': customIsSelected}"
                    class="text-nowrap"
                    @click="$emit('customDimensionsOpen')"
                    v-if="showCustom"
                >{{customDimensionsText}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                current: this.value,
                isOpen: false,
                customDimensionsText: 'Vlastní rozměr'
            };
        },
        props: ["values", "value", "name", "withCustom", "customIsSelected", "dimensions", "disabled", "product", "fabric"],
        computed: {
            showCustom: function () {
                if (this.withCustom) {
                    return true;
                }
                return false;
            },
            selectedText: function () {
                const current = this.current;
                let item = this.flatValues.find(function (item) {
                    if(typeof current === 'object' && current !== null) {
                        return current.id == item.id && current.chainedValue == item.chainedId;
                    } else {
                        return item.id == current;
                    }
                });
                if (this.customIsSelected) {
                    let text = this.customDimensionsText;
                    if(this.dimensions.width) {
                        text += ' '
                            + this.dimensions.width
                            + 'x'
                            + this.dimensions.length
                            + 'cm';
                    }
                    return text;
                } else if (!item) {
                    return this.name;
                } else {
                    if (item.color){
                        return '<span class="color-dot" style="background-color: ' + item.color + '"></span>' + item.label;
                    }
                    return item.label;
                }
            },
            flatValues: function () {
                let values = [];
                values.push({
                    isGroup: false,
                    id: "",
                    groupOption: false,
                    label: this.name,
                    color: null
                });
                var _this = this;
                let modifyLabel = '';

                this.values.forEach(function (item) {
                    if (item.hasOwnProperty("items")) {
                        // values.push({
                        //     isGroup: true,
                        //     id: item.id,
                        //     groupOption: false,
                        //     label: item.label
                        // });
                        if (_this.product.type === 5) {
                            modifyLabel = ' '+item.label;
                        }
                        item.items.forEach(function (gItem) {
                            if(typeof item.label === 'string' && item.label.charAt(0) === '#') {
                                values.push({
                                    isGroup: false,
                                    groupOption: true,
                                    id: gItem.id,
                                    chainedId: item.id,
                                    label: gItem.label + modifyLabel,
                                    color: item.label
                                });
                            } else if(typeof item.label === 'string') {
                                values.push({
                                    isGroup: false,
                                    groupOption: true,
                                    id: gItem.id,
                                    chainedId: item.id,
                                    label: gItem.label + modifyLabel,
                                    color: null
                                });
                            } else {
                                values.push({
                                    isGroup: false,
                                    groupOption: true,
                                    id: gItem.id,
                                    chainedId: item.id,
                                    label: gItem.label + modifyLabel,
                                    color: null
                                });
                            }
                        });
                    } else {
                        values.push({
                            isGroup: false,
                            groupOption: false,
                            id: item.id,
                            label: item.label + modifyLabel
                        });
                    }
                });
                return values;
            }
        },
        methods: {
            setValue(payload) {
                if (!payload.isItem) {
                    return;
                }
                if(payload.chainedId !== undefined) {
                    this.current = {id: payload.value, chainedValue: payload.chainedId};
                } else {
                    this.current = payload.value;
                }
                this.isOpen = false;
                this.$emit("input", this.current);
            },
            close() {
                this.isOpen = false;
            }
        }
    };
</script>

<style>
</style>
